// extracted by mini-css-extract-plugin
export default {"loader":"_styles_loader__Hszxp"};